import { Box, IconButton, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import TextField from "../../../components/form/TextField";
import React, { useEffect, useState } from "react";
import { useUpdateUserMutation } from "../../../api/userApiSlice";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
    data: any;
    edit?: boolean;
    close: () => void;
}

interface FormValues {
    firstName: string;
    lastName: string;
    institution: string;
    email: string;
    position: string;
    pi: string;
    accountExpire: number;
    role: string;
    sites: any[];
}

const ActiveUser = (props: Props) => {
    const [updateUser] = useUpdateUserMutation();
    const { data } = props;
    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm<FormValues>({
        defaultValues: {
            firstName: data.firstName,
            lastName: "fff",
            institution: "",
            email: ""
        },
    });
    const [editable] = useState<boolean>(props.edit ?? false);

    useEffect(() => {
        setValue("firstName", data.firstName);
        setValue("lastName", data.lastName);
        setValue("email", data.email);
    }, [data]);

    const onSubmit = async (newData: FormValues) => {
        const updatedFields: any = {
            FirstName: newData.firstName,
            LastName: newData.lastName
        }
        if (newData.accountExpire !== -1) {
            const activeUntil = new Date();
            activeUntil.setMonth(
                activeUntil.getMonth() + newData.accountExpire
            );
            updatedFields.ActiveUntil = activeUntil.toISOString().split("T")[0];
        }
        const arr = [];
        if (newData.sites.length > 0) {
            for (let i = 0; i < newData.sites.length; i++) {
                arr.push(newData.sites[i].label);
            }
            updatedFields.SiteNames = arr;
        }
        updateUser({
            userID: data.ID,
            fields: updatedFields,
        });
        props.close();
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Typography variant="h6" gutterBottom>
                    User Info
                </Typography>
                <IconButton size="small" onClick={props.close}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            </Box>
            <form
                onSubmit={handleSubmit(onSubmit)}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minWidth: 356,
                }}
            >
                <Controller
                    name={"firstName"}
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                        <TextField
                            label={"First Name"}
                            error={errors.firstName ? true : false}
                            // errorMessage={errors.firstName ? "First name is required" : undefined}
                            disabled={!editable}
                            {...field}
                        />
                    )}
                />
                <Controller
                    name={"lastName"}
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => {
                        return (
                            <TextField
                                label={"Last Name"}
                                error={errors.lastName ? true : false}
                                // errorMessage={errors.lastName ? "Last name is required" : undefined}
                                disabled={!editable}
                                {...field}
                            />
                        );
                    }}
                />
                <Controller
                    name={"email"}
                    control={control}
                    rules={{ required: true }}
                    render={({ field }) => (
                        <TextField
                            label={"Institutional Email Address"}
                            error={errors.email ? true : false}
                            // errorMessage={errors.email ? "Email is required" : undefined}
                            disabled={true}
                            {...field}
                        />
                    )}
                />
            </form>
        </Box>
    );
};

export default ActiveUser;
